import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon, Input, Select, SelectItem, IndexPath} from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, View } from 'react-native';
import { TopBar } from '../topBar.js'
import trackerApi from '../../../api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { showMessage, hideMessage } from "react-native-flash-message";
import * as RootNavigation from '../../../../root.navigation.js';

const width = Dimensions.get('window').width;


const PlusIcon = (props) => (
  <Icon {...props} name='paper-plane' />
);


const TextIcon = (props) => (
  <Icon {...props} name='file-text' />
);


const TextIcon2 = (props) => (
  <Icon {...props} name='menu' />
);

export const NewReqScreen = () => {
  const [subject, setSubject] = useState('');
  const [subjectStatus, setSubjectStatus] = useState('basic')
  const [selectedIndex, setSelectedIndex] = useState(new IndexPath(0));
  const [data, setData] = useState([]);

  const [context, setContext] = useState('');
  const [contextStatus, setContextStatus] = useState('basic')

  React.useEffect(()=>{
    getData()
  },[])

  const getData = async()=>{
    const response = await trackerApi.post('/tickets/category');
    console.log('test', response.data.allData);
    setData(response.data.allData);
  }

  const sendReq =async()=>{
    if(subject.length<3) setSubjectStatus('danger'); else setSubjectStatus('basic')
    if(context.length<10) setContextStatus('danger'); else setContextStatus('basic')
    if(subject.length>2 && context.length>9){
      console.log('test');
      const token =  await AsyncStorage.getItem('userId');
      const response = await trackerApi.post('/tickets/newquery',{
        category:data[selectedIndex.row]['cat_name'],
        topic: subject,
        problem: context,
      }, {
        headers: {Authorization: `Bearer ${token}`}
      });

      if(response.data.status)
      {
        showMessage({
          message: response.data.message,
          type: "success",
        });
        RootNavigation.navigate('Menu')

      } else{
        showMessage({
          message: response.data.message,
          type: "danger",
        })
      }
    }
  }
  return (

      <Layout style={styles.container} level='2' >
        <View style={{flex:1,justifyContent:'flex-start'}}>
          <TopBar title='درخواست جدید' />
          <ScrollView>
          <Select
            style={{flex:1, margin:20}}
            label={evaProps => <Text {...evaProps}>موضوع مورد نظر خود را انتخاب نمایید:</Text>}
            value = {(data.length>0?data[selectedIndex.row]['cat_name']:null)}

            selectedIndex={selectedIndex}
            onSelect={index => setSelectedIndex(index)}>
            {
              data.map((data)=>{
                return (
                  <SelectItem title={data.cat_name} key={selectedIndex} />
                )
              })
            }
          </Select>
          <Input
            style={{flex:1,  marginHorizontal:20, marginVertical:5}}
            label={evaProps => <Text {...evaProps}>عنوان درخواست</Text>}
            placeholder ='عنوان درخواست'
            value={subject}
            accessoryLeft={TextIcon}
            multiline={true}
            onChangeText = {newValue =>{ setSubject(newValue)}}
            status = { subjectStatus }
            />

            <Input
              style={{flex:1, margin:20}}
              label={evaProps => <Text {...evaProps}>شرح مشکل</Text>}
              placeholder ='سوال مورد نظر خود را بپرسید'
              value={context}
              accessoryLeft={TextIcon2}
              multiline={true}
              onChangeText = {newValue =>{ setContext(newValue)}}
              status = { contextStatus }
              />
            </ScrollView>
            </View>
          <View style={{flexDirection:'row' ,width: width-20, marginTop:15, marginBottom:30}}>
          <Button
          style={{flex:2, marginRight:15}}
          appearance='ghost'
          onPress={()=>{RootNavigation.navigate('Menu')}}
          >بازگشت
          </Button>
          <Button
            style={{flex:3}}
              accessoryLeft={PlusIcon}
              onPress = {sendReq }
              >ارسال درخواست
            </Button>
            </View>
      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'space-between',

  },
});
